import React, { useState } from "react";

export default function UpdateNotification({ onUpdate }) {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    setClicked(true);    // Skjul etter klikk
    onUpdate();          // Trigger oppdatering
  };

  if (clicked) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      width: "100%",
      backgroundColor: "#002d72",
      color: "#fff",
      padding: "1rem",
      textAlign: "center",
      zIndex: 1000
    }}>
      🔄 Ny versjon tilgjengelig.
      <button
        style={{
          marginLeft: "1rem",
          padding: "0.5rem 1rem",
          backgroundColor: "#cedc00",
          color: "#002d72",
          border: "none",
          borderRadius: "5px",
          fontWeight: "bold",
          cursor: "pointer"
        }}
        onClick={handleClick}
      >
        Oppdater nå
      </button>
    </div>
  );
}

